import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { getComponentFromRoute } from '../../../utils/sitecorePlaceholders';
import { useUserOrDefaultProvince } from '../../../utils/sitecoreContext';
var PROGRESS_BAR_COMPONENT_NAME = 'ProgressBar';
var provincesToHideDealer = ['MB'];
var useHideDealerByProvinces = function () {
    var _a;
    var sitecoreContext = useSitecoreContext().sitecoreContext;
    var provinceCode = useUserOrDefaultProvince();
    var progressBarComponent = getComponentFromRoute(PROGRESS_BAR_COMPONENT_NAME, sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.route);
    var isBapVariant = ((_a = progressBarComponent === null || progressBarComponent === void 0 ? void 0 : progressBarComponent.params) === null || _a === void 0 ? void 0 : _a.variant) === 'variant1';
    return {
        isBapVariant: isBapVariant,
        hideDealer: isBapVariant && provincesToHideDealer.includes(provinceCode),
    };
};
export default useHideDealerByProvinces;
